import React, { useEffect, useMemo, useState } from "react";
import {
  Box, Typography, Grid, Button, RadioGroup, FormControlLabel, Radio,
  Modal,
} from "@mui/material";
import { colorAndWeightChecker, pickSizePackPrice, PriceCalculator } from "../selectPriceForProduct";
import { useProductStore } from "../../store/useProductStore";
import deliveryIcon from "../../assests/icon-delivery.png";
import ProductSelector from "../../api/ProductSelector";
import { useAuthStore } from "../../store/useAuthStore";
import { useCartStore } from "../../store/useCartStore";
import { AiOutlineShoppingCart } from "react-icons/ai";
import returnIcon from "../../assests/Icon-return.png";
import { Link, useNavigate } from "react-router-dom";
import { FiMinus, FiPlus } from "react-icons/fi";
import ProductImages from "./ProductImages";
import Loader from "../Loader/Loader";
import toast from "react-hot-toast";
import { Tooltip } from '@mui/material';
import "../../screens/Cart.css";
import "./radioButton.css";


const ProductInfo = () => {
  const { authUser } = useAuthStore()
  const { updateQuantity, addtoCart, loading } = useCartStore()

  const navigate = useNavigate()
  const [color, setColor] = useState('');
  const [sizeId, setSizeId] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [discount, setDiscount] = useState(null);
  const [colorOption, setColorOption] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);
  const [finalPrice, setFinalPrice] = useState(null);
  const [retailPrice, setRetailPrice] = useState(null);
  const [selectedSize, setSelectedSize] = useState("");
  const [selectedWeight, setSelectedWeight] = useState("");
  const [selectedWeightArray, setSelectedWeightArray] = useState([]);
  const [unitOptionsArray, setUnitOptionsArray] = useState([]);
  const [size_attributeId, setSize_attributeId] = useState(null);
  const [displayNotes, setDisplayNotes] = useState(null);
  const { selectedProduct, setselectedProductToBuy } = useProductStore()

  const handleSizeChange = (size) => {
    setSelectedSize(size);

    const matchedAttribute = selectedProduct.attributes.find(
      (attr) => attr.size === size
    );

    if (matchedAttribute) {
      const units = matchedAttribute.size_attribute.map(
        (item) => item.pack_per_unit_options
      );

      const color = matchedAttribute.size_attribute.map(
        (item) => item?.color
      );
      setUnitOptionsArray(units);
    } else {
      setUnitOptionsArray([]);
    }
  };

  const sizeChange = (e) => {
    // console.log(selectedSize)
    setSelectedSize(e)
    setColor('')
    // console.log(e)
  }

  const handleAddToCart = async () => {

    if (!sizeId || !size_attributeId) {
      toast.error("Please Select the size");
      return
    }

    if (!authUser) {
      navigate("/login")
    }

    try {
      const data = await addtoCart(selectedProduct._id, sizeId, size_attributeId, quantity, color, selectedWeight)
      if (data)
        navigate("/cart")
    } catch (error) {
      console.log(error)
    }
  }

  const handleBuyProduct = async () => {
    try {
      const missingFields = [];
      if (!selectedProduct?._id) missingFields.push("selectedProduct._id");
      if (!sizeId) missingFields.push("sizeId");
      if (!size_attributeId) missingFields.push("size_attributeId");
      if (!quantity) missingFields.push("quantity");



      if (missingFields.length > 0) {
        const errorMessage = `Missing fields: ${missingFields.join(", ")}`;
        toast.error(errorMessage);
        return
      } else {
        console.log("All fields are present.");
      }


      const data = {
        productId: selectedProduct._id,
        name: selectedProduct.name,
        brand: selectedProduct.brand,
        images: selectedProduct.images,
        sizeId,
        size_attributeId,
        quantity,
        color,
        size: selectedSize,
        weight: selectedWeight,
        total: finalPrice * quantity
      }

      if (!colorAndWeightChecker(selectedProduct, sizeId, size_attributeId, color, selectedWeight))
        return

      setselectedProductToBuy(data)
      navigate('/checkout', { state: { throughCart: false } });
      // console.log(data)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (selectedProduct?.attributes?.length > 0) {
      const data = PriceCalculator(selectedProduct.attributes, selectedSize, null, null);
      console.log("Picked data", data);
      if (data?.pack) {
        setUnitOptions(data.pack)
      }
      setSelectedWeightArray(data?.weight)
      setFinalPrice(data?.finalPrice)
      setRetailPrice(data?.retailPrice)
      setDiscount(data?.discountPercent)
      handleSizeChange(data?.size);
      setColorOption(data?.color);
      setSizeId(data?.sizeId);
      setSize_attributeId(data?.size_attributeId);

      // console.log("selectedProduct", selectedProduct)
    }
  }, [selectedProduct, selectedSize, unitOptions]);

  return (
    <Grid
      container
      spacing={2}
      sx={{
        width: "100%",
        margin: {
          xs: "0px 0 40px",
          sm: "0px 0 40px",
          md: "20px 0",
          lg: "60px 0",
        },
      }}
    >
      <Loader loading={loading} />
      <Grid
        item
        size={{ xs: 12, sm: 12, md: 6, lg: 6 }}
        sx={{ paddingLeft: { xs: "0 !important", sm: "0 !important" } }}
      >
        <ProductImages images={selectedProduct?.images} />
      </Grid>
      <Grid
        item
        size={{ xs: 12, sm: 12, md: 6, lg: 6 }}
        sx={{ paddingLeft: { xs: "0 !important", sm: "0 !important" } }}
      >
        <Box
          sx={{
            paddingLeft: {
              xs: "0 !important",
              sm: "0 !important",
              md: "20px !important",
              lg: "40px !important",
            },
            paddingTop: {
              xs: "15px  !important",
              sm: "20px !important",
              md: "0 !important",
              lg: "0 !important",
            },
          }}
        >
          <Typography
            variant="h2"
            sx={{
              fontFamily: `"Quicksand", sans-serif`,
              fontWeight: 600,
              fontSize: { xs: "22px", sm: "22px", md: "24px", lg: "24px" },
              lineHeight: {
                xs: "26.37px",
                sm: "30px",
                md: "36px",
                lg: "40.76px",
              },
              margin: "0 0 0px",
              color: "#000",
              textAlign: "Left",
            }}
          >
            {selectedProduct?.name}
          </Typography>

          <Typography
            sx={{
              fontSize: "16px",
              lineHeight: "24px",
              fontWeight: "400",
              fontFamily: `"Lato", sans-serif`,
              color: "#B6B6B6",
              marginBottom: "10px",
              "& span": {
                color: "#000",
                // marginLeft: "10px",
              },
            }}
          >
            Brand <span>{selectedProduct?.brand}</span>
          </Typography>

          <Typography
            variant="h1"
            sx={{
              fontFamily: `"Quicksand", sans-serif`,
              fontWeight: 600,
              fontSize: "32px",
              lineHeight: "35px",
              color: "#000",
              textAlign: { xs: "center", sm: "center", md: "Left", lg: "Left" },
              "& strike": {
                color: "#EB2A2D",
              },
              "& .retailprice": {
                marginLeft: "10px",
              },
              "& .discount": {
                marginTop: "10px",
                display: "block",
                fontSize: { xs: "14px", sm: "15px", md: "18px", lg: "18px" },
                lineHeight: { xs: "18px", sm: "20px", md: "22px", lg: "22px" },
              },
            }}
          >
            {selectedProduct?.isPriceDisplay && (
              <>
                {finalPrice != null && <span>{`$${finalPrice}`}</span>}
              </>
            )}
          </Typography>

          {/* <Typography
            variant="h2"
            sx={{
              fontFamily: `"Lato", sans-serif`,
              fontWeight: 400,
              fontSize: { xs: "12px", sm: "15px", md: "15px", lg: "16px" },
              lineHeight: { xs: "18px", sm: "20px", md: "22px", lg: "24px" },
              margin: "0 0 20px",
              color: "#3C3C3C",
              textAlign: { xs: "center", sm: "center", md: "Left", lg: "Left" },
              // borderBottom: "1px solid #000000",
            }}
          >
            {selectedProduct?.description.length ? selectedProduct?.description.substring(0, 150) + "..." : selectedProduct?.description}
          </Typography> */}

          <Typography
            sx={{
              fontSize: "16px",
              lineHeight: "20px",
              fontWeight: "400",
              fontFamily: `"Lato", sans-serif`,
              color: "#000",
              marginBottom: "10px",
              "& span": {
                color: "#000",
                // marginLeft: "10px",
              },
            }}
          >
            Experience unmatched quality and performance with our premium product.it’s the perfect addition to your lifestyle.
          </Typography>

          <div
            style={{
              display: "flex",
              gap: "16px",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px"
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column"
              }}
            >

              {/* Unit Drop-down */}
              <Box className="color-picker-wrapper" sx={{
                display: "flex",
                flexDirection: "column", // stack color and weight sections vertically
                gap: "12px", // spacing between color and weight sections
                marginBottom: "15px",
              }}>
                {/* Color Section */}
                {colorOption && colorOption.length > 0 && (
                  <>
                    {color && (
                      <Box sx={{ mt: 1 }}>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                          <b>Selected Color:</b> <span style={{ textTransform: 'capitalize' }}>{color}</span>
                        </Typography>
                      </Box>
                    )}
                    <Box sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      flexWrap: "wrap",
                    }}>
                      <label className="lable-custom-width">Color :</label>
                      {colorOption.map((unit, index) => (
                        unit ? (
                          <Box key={index}
                            sx={{
                              "& input[type='radio'].color-button": {
                                accentColor: `${unit}`,
                                width: "25px",
                                height: "25px",
                                margin: "0",
                                WebkitAppearance: "none",
                                borderRadius: "50%",
                                outline: "none",
                                border: `2px solid ${unit}`,
                                backgroundColor: "rgba(247, 245, 245, 1)",
                                cursor: "pointer",
                              },
                              "& input[type='radio'].color-button:before": {
                                content: `''`,
                                display: "block",
                                width: "100%",
                                height: "100%",
                                borderRadius: "50%",
                              },
                              "& input[type='radio'].color-button:checked:before": {
                                background: `${unit}`,
                              },
                              "& input[type='radio'].color-button:checked": {
                                borderColor: `${unit}`,
                              },
                            }}>
                            <Tooltip title={unit.toUpperCase()} arrow placement="top" enterDelay={200}>
                              <input
                                type="radio"
                                value={unit}
                                name="color-button"
                                className="color-button"
                                onChange={(e) => setColor(e.target.value)}
                                checked={color === unit && colorOption.includes(unit)}
                              />
                            </Tooltip>
                          </Box>
                        ) : null
                      ))}
                      {/* Selected color name in next line */}

                    </Box>
                  </>
                )}


                {/* Weight Section */}
                {selectedWeightArray && selectedWeightArray.length > 0 && (
                  <Box sx={{
                    display: "flex",
                    gap: "10px",
                    flexWrap: "wrap",
                    alignItems: "center",

                  }}>
                    <label className="lable-custom-width">Weight :</label>
                    {selectedWeightArray.map((unit, index) => (
                      <Box key={index}>
                        <label style={{ cursor: 'pointer' }}>
                          <input
                            type="radio"
                            name="weight"
                            value={unit}
                            onChange={(e) => setSelectedWeight(e.target.value)}
                            disabled={!unitOptionsArray.length}
                            style={{ display: 'none' }}
                            className="weight-radio"
                          />
                          <Box
                            component="span"
                            sx={{
                              px: 1,
                              py: 1,
                              border: `2px solid ${selectedWeight === unit ? '#1976d2' : '#ccc'}`,
                              // borderRadius: '50px',
                              backgroundColor: selectedWeight === unit ? '#e3f2fd' : '#fff',
                              fontWeight: selectedWeight === unit ? 'bold' : 'normal',
                              color: selectedWeight === unit ? '#1976d2' : 'inherit',
                              display: 'inline-block',
                            }}
                          >
                            {unit}
                          </Box>
                        </label>
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>

              {!(selectedProduct?.attributes === 0) ?
                <Box sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  // gap: "10px",
                  marginBottom: "25px",
                  "& label.sizeLabel": {
                    marginRight: "7px"
                  },
                }}>
                  {Array.isArray(selectedProduct?.attributes) &&
                    selectedProduct.attributes.length > 0 &&
                    selectedProduct.attributes.some(attr => attr?.size?.trim()) && (
                      <div className="flex flex-col bg-pink-200"
                        style={{
                          "display": "flex",
                          alignItems: "center",
                        }}>
                        <label className="sizeLabel lable-custom-width">Size:</label>
                        {selectedProduct.attributes.map((attr, index) => (
                          attr?.size?.trim() && (
                            <div
                              className="sizeButton"
                              key={index}
                              style={{
                                "width": "80px"
                              }}
                            >
                              <input
                                type="radio"
                                id={`size-${attr.size}`}
                                value={attr.size}
                                name="size-button"
                                onChange={(e) => {
                                  sizeChange(e.target.value);
                                }}
                                checked={selectedSize === attr.size}
                              />
                              <label className="btn btn-default" htmlFor={`size-${attr.size}`}>
                                {attr.size}
                              </label>
                            </div>
                          )
                        ))}
                      </div>
                    )}

                </Box>
                : " "}
            </Box>
            {
              selectedProduct?.displayNotes &&
              <div>
                <Button
                  variant="contained"
                  sx={{
                    display: "flex",
                    textAlign: "center",
                    background: "transparent",
                    // width: "150px",
                    height: {
                      xs: "36px",
                      sm: "36px",
                      md: "42px",
                      lg: "42px",
                    },
                    borderRadius: "4px",
                    border: "1px solid rgba(0, 0, 0, 0.5)",
                    color: "#000",
                    boxShadow: "none",
                    fontFamily: `"Quicksand", sans-serif`,
                    fontWeight: 500,
                    fontSize: {
                      xs: "12px",
                      sm: "15px",
                      md: "15px",
                      lg: "16px",
                    },
                    lineHeight: {
                      xs: "18px",
                      sm: "20px",
                      md: "22px",
                      lg: "24px",
                    },
                    textTransform: "capitalize",
                    "& svg": {
                      fontSize: "22px",
                      marginLeft: "5px",
                    }
                  }}
                  onClick={() => setDisplayNotes(prev => !prev)}
                >
                  View Note
                  {/* <AiOutlineShoppingCart /> */}
                </Button>
              </div>
            }
          </div>

          <div style={{
            display: "flex", gap: "0.5rem",
            justifyContent: "space-between",
          }}>
            <div className="counter cartQuantity">
              <button
                className="buttonDectoCart"
                onClick={() => setQuantity((prev) => prev > 1 ? prev - 1 : prev)}
                disabled={quantity <= 1}
              >
                <FiMinus />
              </button>
              <p className="textAddtoCart">{quantity}</p>
              <button
                className="buttonAddtoCart"
                onClick={() => setQuantity((prev) => prev + 1)}
              >
                <FiPlus />
              </button>
              {/* <button onClick={() => remove(id)} className='remove-item'>Remove Form Cart</button> */}
            </div>
            <Box sx={{
              display: "flex",
              gap: "10px",
            }}>
              <Button
                variant="contained"
                onClick={handleBuyProduct}
                sx={{
                  display: "block",
                  textAlign: "center",
                  background: "#008BFF",
                  // width: "120px",
                  height: {
                    xs: "36px",
                    sm: "36px",
                    md: "42px",
                    lg: "42px",
                  },
                  borderRadius: "4px",
                  color: "#FAFAFA",
                  boxShadow: "none",
                  fontFamily: `"Quicksand", sans-serif`,
                  fontWeight: 500,
                  fontSize: {
                    xs: "12px",
                    sm: "15px",
                    md: "15px",
                    lg: "16px",
                  },
                  lineHeight: {
                    xs: "18px",
                    sm: "20px",
                    md: "22px",
                    lg: "24px",
                  },
                  textTransform: "capitalize",
                }}
              >
                Buy Now
              </Button>
              <Button
                variant="contained"
                sx={{
                  display: "flex",
                  textAlign: "center",
                  background: "transparent",
                  // width: "150px",
                  height: {
                    xs: "36px",
                    sm: "36px",
                    md: "42px",
                    lg: "42px",
                  },
                  borderRadius: "4px",
                  border: "1px solid rgba(0, 0, 0, 0.5)",
                  color: "#000",
                  boxShadow: "none",
                  fontFamily: `"Quicksand", sans-serif`,
                  fontWeight: 500,
                  fontSize: {
                    xs: "12px",
                    sm: "15px",
                    md: "15px",
                    lg: "16px",
                  },
                  lineHeight: {
                    xs: "18px",
                    sm: "20px",
                    md: "22px",
                    lg: "24px",
                  },
                  textTransform: "capitalize",
                  "& svg": {
                    fontSize: "22px",
                    marginLeft: "5px",
                  }
                }}
                onClick={() => handleAddToCart()}
              >
                Add to Cart
                {/* <AiOutlineShoppingCart /> */}
              </Button>
            </Box>
          </div>
          {/* add delivery details  */}
          <Box
            sx={{
              border: "1px solid rgba(0, 0, 0, 0.5)",
              borderRadius: "4px",
              marginTop: "25px",
              "& .deliveryInfo": {
                fontFamily: `"Quicksand", sans-serif`,
                fontWeight: 500,
                fontSize: { xs: "12px", sm: "15px", md: "15px", lg: "16px" },
                lineHeight: { xs: "18px", sm: "20px", md: "22px", lg: "24px" },
                margin: "0",
                color: "#000",
                textAlign: {
                  xs: "center",
                  sm: "center",
                  md: "Left",
                  lg: "Left",
                },
                display: "flex",
                alignItems: "center",
                gap: "15px",
                // height: "90px",
                padding: "16px 15px",
              },
              "& .subcontDel": {
                display: "block",
                fontFamily: `"Lato", sans-serif`,
                fontWeight: 500,
                fontSize: "12px",
                lineHeight: "18px",
                paddingTop: "8px",
              },
              "& .subcontDel a": {
                textDecoration: "underline !important",
                color: "#000",
              },
            }}
          >
            <Typography
              variant="h2"
              className="deliveryInfo"
              sx={{
                borderBottom: "1px solid rgba(0, 0, 0, 0.5)",
              }}
            >
              <span>
                <img src={deliveryIcon} alt="icon" />
              </span>
              <span>
                Free Delivery
                <span className="subcontDel">
                  <Link to="#">
                    Enter your postal code for Delivery Availability
                  </Link>
                </span>
              </span>
            </Typography>
            <Typography variant="h2" className="deliveryInfo">
              <span>
                <img src={returnIcon} alt="icon" />
              </span>
              <span>
                Return Delivery
                <span className="subcontDel">
                  Free 30 Days Delivery Returns.
                  <Link to="#">Details</Link>
                </span>
              </span>
            </Typography>
          </Box>

        </Box>

      </Grid>

      <Modal
        open={displayNotes}
        aria-labelledby="display-notes-modal"
        aria-describedby="modal-to-show-notes"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: '#fff',
            padding: { xs: '20px', md: '30px' },
            borderRadius: '12px',
            boxShadow: 6,
            width: { xs: "90%", sm: "500px" },
            maxHeight: "80vh",
            overflowY: "auto",
            textAlign: 'left',
          }}
        >
          <Typography
            sx={{
              fontSize: "16px",
              lineHeight: "20px",
              fontWeight: "400",
              fontFamily: `"Lato", sans-serif`,
              color: "#000",
              marginBottom: "10px",
              "& span": {
                color: "#000",
              },
            }}
          >
            {selectedProduct?.notes || "No notes available"}
          </Typography>

          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              variant="contained"
              onClick={() => setDisplayNotes(prev => !prev)}
              sx={{
                backgroundColor: '#274156',
                color: '#fff',
                textTransform: 'none',
                paddingX: 3,
                paddingY: 1,
                borderRadius: 2,
                "&:hover": {
                  backgroundColor: '#1f2a38'
                }
              }}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>

    </Grid>
  );
};

export default ProductInfo;
